<template>
    <div class="ls-pagination--container">
        <span>
            {{ paginationInfo }}
        </span>
        <BPagination
            :total="pagination.totalItems"
            :current="pagination.currentPage"
            :range-before="2"
            :range-after="2"
            order="is-centered"
            size=""
            :per-page="pagination.itemsPerPage"
            icon-prev="chevron-left"
            icon-next="chevron-right"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            @change="changePage"
        >
            <BPaginationButton
                slot="previous"
                slot-scope="props"
                :page="props.page"
                test-id="previous-button"
            >
                &#x3C;
            </BPaginationButton>
            <BPaginationButton
                :id="`page${props.page.number}`"
                slot-scope="props"
                :page="props.page"
            >
                {{ props.page.number }}
            </BPaginationButton>
            <BPaginationButton
                slot="next"
                slot-scope="props"
                :page="props.page"
                test-id="next-button"
            >
                &#x3E;
            </BPaginationButton>
        </BPagination>
    </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsPagination',
    props: {
        pagination: VueTypes.shape({
            totalItems: VueTypes.number.isRequired,
            currentPage: VueTypes.number.isRequired,
            itemsPerPage: VueTypes.number.isRequired,
        }).isRequired,
        changePage: VueTypes.func.isRequired,
        tableType: VueTypes.string.def('Customers'),
    },
    computed: {
        paginationInfo() {
            const { currentPage, itemsPerPage, totalItems } = this.pagination;

            let firstNumber = 1;
            if (currentPage > 1) {
                firstNumber = (currentPage - 1) * itemsPerPage + 1;
            }
            const lastNumber = firstNumber + this.perPage - 1;

            return `Showing ${firstNumber} - ${lastNumber} of ${totalItems} ${this.tableType}`;
        },
        perPage() {
            return this.pagination.currentPage * this.pagination.itemsPerPage <
                this.pagination.totalItems
                ? this.pagination.itemsPerPage
                : Math.floor(this.pagination.totalItems % 10);
        },
    },
};
</script>

<style lang="scss">
.ls-pagination--container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
}

.pagination-previous,
.pagination-next {
    background-color: #f0f3ff;
}

.pagination-previous[disabled],
.pagination-next[disabled] {
    background-color: #f0f3ff !important;
}

.pagination-list {
    justify-content: space-evenly !important;

    .pagination-link.is-current {
        background-color: $primary;
        color: white !important;
    }
}

.pagination-ellipsis {
    font-size: 15px !important;
    color: #93a2dd !important;
}

.pagination-link {
    color: #93a2dd !important;
    border-color: transparent !important;
}
</style>
